export const APP_VERSION = '79446ff';
